module.exports = __webpack_public_path__ + "static/media/jackpot.d5f41e14.png";